import type { Conversation } from './conversations-model'

export type ConversationWorkspaceTab = 'sms' | 'calls'

export function initialWorkspaceTabForConversation(
  conversation: Conversation
): ConversationWorkspaceTab {
  if (
    conversation.channel === 'Voice' &&
    conversation.availableChannels.includes('Voice')
  ) {
    return 'calls'
  }
  if (
    conversation.channel === 'SMS' &&
    conversation.availableChannels.includes('SMS')
  ) {
    return 'sms'
  }
  const hasVoice = conversation.availableChannels.includes('Voice')
  const hasSms = conversation.availableChannels.includes('SMS')
  if (hasVoice && !hasSms) return 'calls'
  return 'sms'
}
